import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "xuma_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch { /* ignore */ }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[60] rounded-2xl bg-xuma-dark text-white shadow-2xl border border-white/10 p-5">
      <div className="flex items-start gap-3">
        <span className="h-9 w-9 rounded-xl bg-white/10 grid place-items-center shrink-0">
          <Cookie className="h-4.5 w-4.5 text-xuma-primary" />
        </span>
        <div className="flex-1">
          <p className="font-heading font-bold text-sm">Usamos cookies</p>
          <p className="text-xs text-white/70 mt-1 leading-relaxed">
            Usamos cookies necesarias para el funcionamiento y, con tu permiso, cookies analíticas para mejorar Xuma.
            Consulta nuestra <Link to="/legal/cookies" className="text-xuma-primary hover:underline">Política de Cookies</Link>.
          </p>
          <div className="flex gap-2 mt-3">
            <Button data-testid="cookie-accept" onClick={() => decide("accepted")}
              className="h-9 rounded-full bg-xuma-primary hover:bg-xuma-primaryHover text-white text-sm px-4">
              Aceptar
            </Button>
            <Button data-testid="cookie-reject" onClick={() => decide("rejected")} variant="ghost"
              className="h-9 rounded-full text-white/80 hover:text-white hover:bg-white/10 text-sm px-4">
              Rechazar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
